export const palette = {
  variant1: [
    '#edf8fb',
    '#bfd3e6',
    '#9ebcda',
    '#8c96c6',
    '#8c6bb1',
    '#88419d',
    '#6e016b',
  ],
  variant2: [
    '#fee5d9',
    '#fcbba1',
    '#fc9272',
    '#fb6a4a',
    '#ef3b2c',
    '#cb181d',
    '#99000d',
  ],
  variant3: [
    '#ffffb2',
    '#fed976',
    '#feb24c',
    '#fd8d3c',
    '#fc4e2a',
    '#e31a1c',
    '#b10026',
  ],
  variant4: [
    '#edf8fb',
    '#ccece6',
    '#99d8c9',
    '#66c2a4',
    '#41ae76',
    '#238b45',
    '#005824',
  ],
  variant5: [
    '#f1eef6',
    '#d0d1e6',
    '#a6bddb',
    '#74a9cf',
    '#3690c0',
    '#0570b0',
    '#034e7b',
  ],
  variant6: [
    '#f6eff7',
    '#d0d1e6',
    '#a6bddb',
    '#67a9cf',
    '#3690c0',
    '#02818a',
    '#016450',
  ],
  variant7: [
    '#feebe2',
    '#fcc5c0',
    '#fa9fb5',
    '#f768a1',
    '#dd3497',
    '#ae017e',
    '#7a0177',
  ],
};

export function extractLabeledColor(color) {
  return (label, index) => {
    return [label, color[index]];
  };
}



// WEBPACK FOOTER //
// ./src/utils/colors.js